<template>
  <el-form
      ref="form"
      :model="form"
      label-width="90px"
      class="gj-table-parent_flex"
      :class="{'info-form': viewOpType}"
      :label-suffix="viewOpType ? '' : ''">
    <div class="edit-form">
        <el-form-item
            label="包装尺寸"
            label-width="60px"
            :class="{'row-height': viewOpType}"
            class="gj-union--input">
          <template v-if="viewOpType">
            {{form.packageL | defaultShow}} cm * {{form.packageW | defaultShow}} cm * {{form.packageH | defaultShow}} cm
          </template>
          <template v-else>
            <el-form-item
                prop="packageL"
                class="no-border"
                :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
              <gj-input width="110px" placeholder="长" v-model="form.packageL">
                <template slot="append">cm</template>
              </gj-input>
<!--              <gj-input-->
<!--                  v-model="form.packageL"-->
<!--                  placeholder="长"-->
<!--                  width="110px">-->
<!--                <template #suffix>cm</template>-->
<!--              </gj-input>-->
            </el-form-item>
            <el-form-item
                prop="packageW"
                class="no-left_padding no-border"
                :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
              <gj-input width="110px" placeholder="宽" v-model="form.packageW">
                <template slot="append">cm</template>
              </gj-input>
<!--              <gj-input-->
<!--                  v-model="form.packageW"-->
<!--                  placeholder="宽"-->
<!--                  width="110px">-->
<!--                <template #suffix>cm</template>-->
<!--              </gj-input>-->
            </el-form-item>
            <el-form-item
                prop="packageH"
                class="no-left_padding"
                :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
              <gj-input width="110px" placeholder="高" v-model="form.packageH">
                <template slot="append">cm</template>
              </gj-input>
<!--              <gj-input-->
<!--                  v-model="form.packageH"-->
<!--                  placeholder="高"-->
<!--                  width="110px">-->
<!--                <template #suffix>cm</template>-->
<!--              </gj-input>-->
            </el-form-item>
          </template>
        </el-form-item>
 
 
        <el-form-item
            label="单品毛重"
            prop="packageWeight"
            :class="{'row-height': viewOpType}"
            :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
          <template v-if="viewOpType">{{form.packageWeight | defaultShow('', 'g')}}</template>
          <gj-input v-else v-model="form.packageWeight" width="150px" placeholder="单品毛重">
            <template #append>g</template>
          </gj-input>
        </el-form-item>
  

        <el-form-item
            label="服装类别"
            :class="{'row-height': viewOpType}"
            prop="clothing">
          <template v-if="viewOpType">{{ form.clothing ? '是' : '否' }}</template>
          <gj-select
              v-else
              v-model="form.clothing"
              :options="[
                {id: true, text: '是'},
                {id: false, text: '否'}
              ]"
              :clearable="false"
              width="150px"
              placeholder="服装类别"
          ></gj-select>
        </el-form-item>

    </div>
    <el-row style="flex: 1; overflow: auto">
      <el-col :span="8" style="height: 100%">
        <div class="estimate-wrapper" style="margin-right: 12px">
          <el-row
              type="flex"
              justify="space-between"
              class="estimate__header">
            <div class="estimate--title">美国FBA尾程派送费（预估）</div>
<!--            <el-link-->
<!--                type="primary"-->
<!--                :underline="false"-->
<!--                target="_blank"-->
<!--                href="https://sellercentral.amazon.com/gp/help/external/201112670?language=zh_CN&ref=efph_201112670_cont_201074400"-->
<!--            >参考链接</el-link>-->
            <el-link
                type="primary"
                :underline="false"
                target="_blank"
                href="https://sellercentral.amazon.com/gp/help/external/GABBX6GZPA8MSZGW?language=zh_CN&ref=efph_GABBX6GZPA8MSZGW_cont_201411300"
            >参考链接</el-link>
          </el-row>
          <el-row class="estimate__content" style="flex: 1; overflow: auto">
            <template v-if="isMeaningful(usEvaluate)">
              <p>{{usEvaluate.sizeType}}{{usEvaluate.clothing ? '（服装）' : '（非服装）'}}</p>
              <p>包装尺寸：{{usEvaluate.lengthInch}} * {{usEvaluate.widthInch}} * {{usEvaluate.heightInch}} 英寸</p>
              <p>
                单品毛重：
                <span v-if="usEvaluate.weightOunce < 16">{{usEvaluate.weightOunce}}盎司</span>
                <span v-if="usEvaluate.weightOunce >= 16">{{(usEvaluate.weightOunce / 16) | number(2) | defaultShow}}磅</span>
              </p>
               <p>
                体积重量：
                <span v-if="usEvaluate.volumeWeight < 16">{{usEvaluate.volumeWeight}}盎司</span>
                <span v-if="usEvaluate.volumeWeight >= 16">{{(usEvaluate.volumeWeight / 16) | number(2) | defaultShow}}磅</span>
              </p>
              <p>
                发货重量:
                 <gj-help style="margin-right: 10px;">
                  <div style="margin-bottom: 3px;">体积重量:（长 x 宽 x 高  单位：英寸）/ 139</div>
                  <div style="margin-bottom: 3px;">计费重量:单品毛重和体积重量比较,取较大者</div>
                  <div style="margin-bottom: 3px;">体积重换算只针对除特殊大件和单品毛重小于0.75磅之外的商品。</div>
                </gj-help>
                <span v-if="usEvaluate.deliveryWeightOunce < 16">{{usEvaluate.deliveryWeightOunce}}盎司</span>
                <span v-if="usEvaluate.deliveryWeightOunce >= 16">{{(usEvaluate.deliveryWeightOunce / 16) | number(2) | defaultShow}}磅</span>
              </p>
              <p>
                配送费用：
                {{usEvaluate.freight.currencySymbol | defaultShow}}{{usEvaluate.freight.currencyAmount | defaultShow}}
              </p>
            </template>
            <div v-else class="no-content">暂无内容，请先填写包装尺寸、单品毛重</div>
          </el-row>
        </div>
      </el-col>
      <el-col :span="16" style="height: 100%">
        <div class="estimate-wrapper">
          <el-row
              type="flex"
              justify="space-between"
              class="estimate__header">
            <div class="estimate--title">欧洲FBA尾程派送费（预估）</div>
            <el-link
                type="primary"
                target="_blank"
                :underline="false"
                href="https://sellercentral.amazon.co.uk/gp/help/external/help.html?itemID=ABBX6GZPA8MSZGW&language=zh_CN&ref=efph_ABBX6GZPA8MSZGW_cont_201074400"
            >参考链接</el-link>
          </el-row>
          <el-row class="estimate__content" style="flex: 1; overflow: auto">
            <template v-if="isMeaningful(euEvaluate)">
              <p>{{euEvaluate.firstLevelName}} {{euEvaluate.secondLevelName}}</p>
              <div>
                <span>包装尺寸：{{form.packageL}} * {{form.packageW}} * {{form.packageH}} 厘米</span>
                <span style="margin-left: 40px;">
                  单品毛重：
                  <span v-if="form.packageWeight < 1000">{{form.packageWeight}}克</span>
                  <span v-if="form.packageWeight >= 1000">{{(form.packageWeight / 1000) | number(2)}}千克</span>
                </span>
                <span style="margin-left: 40px;">
                  体积重量：
                  <span v-if="euEvaluate.volumeWeight < 1000">{{euEvaluate.volumeWeight}}克</span>
                  <span v-if="euEvaluate.volumeWeight >= 1000">{{(euEvaluate.volumeWeight / 1000) | number(2)}}千克</span>
                </span>
              </div>
               <p>
                  发货重量:
                   <gj-help style="margin-right: 10px;">
                    <div style="margin-bottom: 3px;">体积重量:（长 x 宽 x 高  单位:  厘米）/ 5000</div>
                    <div style="margin-bottom: 3px;">计费重量:单品毛重和体积重量比较,取较大者</div>
                    <div style="margin-bottom: 3px;">除小号大件、标准大件、大号大件外，其他尺寸层级的计费重为单品毛重</div>
                  </gj-help>
                  <span v-if="euEvaluate.deliveryWeight < 1000">{{euEvaluate.deliveryWeight}}克</span>
                  <span v-if="euEvaluate.deliveryWeight >= 1000">{{(euEvaluate.deliveryWeight / 1000) | number(2)}}千克</span>
                </p>
              <p>配送费用：</p>
              <p>1.本地和亚马逊物流欧洲整合服务</p>
              <div>
               <gj-table
                    :width="'100%'"
                    ref="gjTable"
                    :adapt-height="false"
                    :index="false"
                    :data="tableData"
                    :columns="columns"
                    >
                  <template v-slot:header:ukLocalFee>
                    英国({{euEvaluate.ukLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:deLocalFee>
                    德国({{euEvaluate.deLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:frLocalFee>
                    法国({{euEvaluate.frLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:itLocalFee>
                    意大利({{euEvaluate.itLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:esLocalFee>
                    西班牙({{euEvaluate.esLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:flLocalFee>
                    荷兰({{euEvaluate.flLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:seLocalFee>
                    瑞典({{euEvaluate.seLocalFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:plLocalFee>
                    波兰({{euEvaluate.plLocalFeecurrencySymbol}})
                  </template>

                  <template v-slot:header:ukAmazonEuFee>
                    英国({{euEvaluate.ukAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:deAmazonEuFee>
                    德国({{euEvaluate.deAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:frAmazonEuFee>
                    法国({{euEvaluate.frAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:itAmazonEuFee>
                    意大利({{euEvaluate.itAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:esAmazonEuFee>
                    西班牙({{euEvaluate.esAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:flAmazonEuFee>
                    荷兰({{euEvaluate.flAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:seAmazonEuFee>
                    瑞典({{euEvaluate.seAmazonEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:plAmazonEuFee>
                    波兰({{euEvaluate.plAmazonEuFeecurrencySymbol}})
                  </template>
                  
                </gj-table>

              </div>
              
              <p>2.欧洲配送网络（EFN）</p>
              <div>
                <gj-table
                    :index="false"
                    border
                    ref="gjTable"
                    name="productFbaTailEFN"
                    :data="tableData"
                    :columns="efnColumns"
                    :adapt-height="false">
                  <template v-slot:header:nonUkEuFee>
                    德国/意大利/西班牙/荷兰 ({{euEvaluate.nonUkEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:frEuFee>
                    法国({{euEvaluate.frEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:seEuFee>
                    瑞典（瑞典克朗）({{euEvaluate.seEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:plEuFee>
                    波兰（波兰兹罗提）({{euEvaluate.plEuFeecurrencySymbol}})
                  </template>
                  
                </gj-table>
              </div>
               <p>3.欧洲配送网络促销费用（发往/来自英国）</p>
              <div>
                <gj-table
                    :index="false"
                    border
                    ref="gjTable"
                    name="productFbaTailToEFN"
                    :data="tableData"
                    :columns="toEFNColumns"
                    :adapt-height="false">
    
                  <template v-slot:header:ukToEuFee>
                    英国到德国/意大利/西班牙({{euEvaluate.ukToEuFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:ukToFrFee>
                    英国到法国 ({{euEvaluate.ukToFrFeecurrencySymbol}})
                  </template>
                  <template v-slot:header:euToUkFee>
                    德国/法国/意大利/西班牙到英国 ({{euEvaluate.euToUkFeecurrencySymbol}})
                  </template> 
                </gj-table>
              </div>
              
            </template>
            <div v-else class="no-content">暂无内容，请先填写包装尺寸、单品毛重</div>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import {formRuleMixin, formValidatorMixin, isMeaningfulMixin, opTypeMixin} from "../../../../../../minxins";
  import {isMeaningful} from "../../../../../../utils/common";
  import {getEuFreightEvaluate, getUsFreightEvaluate} from "../../../../../../api/product";
  import {OpEnum} from "../../../../../../utils/options";
import { el } from 'date-fns/locale';

  export default {
    name: "app-product-fba-tail",
    mixins: [formValidatorMixin, formRuleMixin, isMeaningfulMixin, opTypeMixin],
    props: {
      form: {
        required: true
      },
      opType: {
        type: Number,
        default: OpEnum.type.ADD
      }
    },
    data() {
      return {
        tableData: [],
        euEvaluate: null,
        usEvaluate: null,
        OpEnum: OpEnum,
        //本地和亚马逊物流欧洲整合服务
        columns: [
            { 
              id: 'local', header: '本地', align: 'center', 
              children: [
                {id: 'ukLocalFee', header: 'slot:ukLocalFee', field: 'ukLocalFee', minWidth: '70px', align: 'right'},
                {id: 'deLocalFee', header: 'slot:deLocalFee', field: 'deLocalFee', minWidth: '70px', align: 'right'},
                {id: 'frLocalFee', header: 'slot:frLocalFee', field: 'frLocalFee', minWidth: '70px', align: 'right'},
                {id: 'itLocalFee', header: 'slot:itLocalFee', field: 'itLocalFee', minWidth: '80px', align: 'right'},
                {id: 'esLocalFee', header: 'slot:esLocalFee', field: 'esLocalFee', minWidth: '80px', align: 'right'},
                {id: 'flLocalFee', header: 'slot:flLocalFee', field: 'flLocalFee', minWidth: '80px', align: 'right'},
                {id: 'seLocalFee', header: 'slot:seLocalFee', field: 'seLocalFee', minWidth: '80px', align: 'right'},
                {id: 'plLocalFee', header: 'slot:plLocalFee', field: 'plLocalFee', minWidth: '80px', align: 'right'},
              ]
            },
            {
                id: 'eu', header: '亚马逊物流欧洲整合服务', align: 'center', 
                children: [
                  {id: 'ukAmazonEuFee', header: 'slot:ukAmazonEuFee', field: 'ukAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'deAmazonEuFee', header: 'slot:deAmazonEuFee', field: 'deAmazonEuFee', minWidth: '70px', align: 'right'},
                  {id: 'frAmazonEuFee', header: 'slot:frAmazonEuFee', field: 'frAmazonEuFee', minWidth: '70px', align: 'right'},
                  {id: 'itAmazonEuFee', header: 'slot:itAmazonEuFee', field: 'itAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'esAmazonEuFee', header: 'slot:esAmazonEuFee', field: 'esAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'flAmazonEuFee', header: 'slot:flAmazonEuFee', field: 'flAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'seAmazonEuFee', header: 'slot:seAmazonEuFee', field: 'seAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'plAmazonEuFee', header: 'slot:plAmazonEuFee', field: 'plAmazonEuFee', minWidth: '80px', align: 'right'},
                ]
              },

        ],
        //欧洲配送网络（EFN）
        efnColumns: [
          {id: 'nonUkEuFee', header: 'slot:nonUkEuFee', field: 'nonUkEuFee', minWidth: '230px', align: 'right'},
          {id: 'frEuFee', header: 'slot:frEuFee', field: 'frEuFee', minWidth: '80px', align: 'right'},
          {id: 'seEuFee', header: 'slot:seEuFee', field: 'seEuFee', minWidth: '150px', align: 'right'},
          {id: 'plEuFee', header: 'slot:plEuFee', field: 'plEuFee', minWidth: '230px', align: 'right'},
        ],
        //欧洲配送网络促销费用（发往/来自英国）
        toEFNColumns: [
          {id: 'ukToEuFee', header: 'slot:ukToEuFee', field: 'ukToEuFee', minWidth: '230px', align: 'right'},
          {id: 'ukToFrFee', header: 'slot:ukToFrFee', field: 'ukToFrFee', minWidth: '150px', align: 'right'},
          {id: 'euToUkFee', header: 'slot:euToUkFee', field: 'euToUkFee', minWidth: '230px', align: 'right'},
        ],
        init: true
      }
    },
    watch: {
      form: {
        handler(form) {
          if (isMeaningful(form.packageL)
            && isMeaningful(form.packageW)
            && isMeaningful(form.packageH)
            && isMeaningful(form.packageWeight)) {
            if (this.opType === OpEnum.type.VIEW
              || (this.init && this.opType === OpEnum.type.UPDATE)
              || (this.$refs.form && this.formValidate())) {
              const params = {
                clothing: this.form.clothing,
                height: this.form.packageH,
                length: this.form.packageL,
                width: this.form.packageW,
                weight: this.form.packageWeight
              };
              getUsFreightEvaluate(params)
                .then((data) => {
                  this.usEvaluate = data;
                });
              getEuFreightEvaluate(params)
                .then((data) => {
                  
                  var infoData = this.getInfoData(data, {});
                  this.tableData = [infoData];
                  this.euEvaluate = infoData;
                  this.setColumns(this.euEvaluate.firstLevelName)
                });
              if (this.init && this.opType === OpEnum.type.UPDATE) {
                this.init = false;
              }
            }
          } else {
            this.euEvaluate = null;
            this.usEvaluate = null;
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      //V2数据整理,属性值平铺
      getInfoData(data, info, keyName) {
        for (let key in data) {
          var str = key;
          if (keyName) {
            if (key == "currencyAmount") {
              str = keyName
            }else {
              str = keyName + key
            }  
          }
          if (data[key] != undefined) {
            if (typeof data[key] === 'object' && isNaN(data[key].length)) {
                this.getInfoData(data[key], info, str)
            } else {
                info[str] = data[key]
            }
          }
          
        }
        return info
      },
      setColumns(key) {
        // console.log('zs', key);
        switch (key) {
          case "标准尺寸":
            this.columns = [
              { 
                id: 'local1', header: '本地和亚马逊物流欧洲整合服务', align: 'center', 
                children: [
                  {id: 'ukLocalFee', header: 'slot:ukLocalFee', field: 'ukLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'deLocalFee', header: 'slot:deLocalFee', field: 'deLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'frLocalFee', header: 'slot:frLocalFee', field: 'frLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'itLocalFee', header: 'slot:itLocalFee', field: 'itLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'esLocalFee', header: 'slot:esLocalFee', field: 'esLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'flLocalFee', header: 'slot:flLocalFee', field: 'flLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'seLocalFee', header: 'slot:seLocalFee', field: 'seLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'plLocalFee', header: 'slot:plLocalFee', field: 'plLocalFee', minWidth: '80px', align: 'right'},
                ]
              }
            ]
            break;
          case "大件":
            this.columns = [
              { 
                id: 'local2', header: '本地', align: 'center', 
                children: [
                  {id: 'ukLocalFee', header: 'slot:ukLocalFee', field: 'ukLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'deLocalFee', header: 'slot:deLocalFee', field: 'deLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'frLocalFee', header: 'slot:frLocalFee', field: 'frLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'itLocalFee', header: 'slot:itLocalFee', field: 'itLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'esLocalFee', header: 'slot:esLocalFee', field: 'esLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'flLocalFee', header: 'slot:flLocalFee', field: 'flLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'seLocalFee', header: 'slot:seLocalFee', field: 'seLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'plLocalFee', header: 'slot:plLocalFee', field: 'plLocalFee', minWidth: '80px', align: 'right'},
                ]
              },
              {
                id: 'eu2', header: '亚马逊物流欧洲整合服务', align: 'center', 
                children: [
                  {id: 'ukAmazonEuFee', header: 'slot:ukAmazonEuFee', field: 'ukAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'deAmazonEuFee', header: 'slot:deAmazonEuFee', field: 'deAmazonEuFee', minWidth: '70px', align: 'right'},
                  {id: 'frAmazonEuFee', header: 'slot:frAmazonEuFee', field: 'frAmazonEuFee', minWidth: '70px', align: 'right'},
                  {id: 'itAmazonEuFee', header: 'slot:itAmazonEuFee', field: 'itAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'esAmazonEuFee', header: 'slot:esAmazonEuFee', field: 'esAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'flAmazonEuFee', header: 'slot:flAmazonEuFee', field: 'flAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'seAmazonEuFee', header: 'slot:seAmazonEuFee', field: 'seAmazonEuFee', minWidth: '80px', align: 'right'},
                  {id: 'plAmazonEuFee', header: 'slot:plAmazonEuFee', field: 'plAmazonEuFee', minWidth: '80px', align: 'right'},
                ]
              },
            ]
            break;
          case "重型大件":
            this.columns = [
              { 
                id: 'local3', header: '本地', align: 'center', 
                children: [
                  {id: 'ukLocalFee', header: 'slot:ukLocalFee', field: 'ukLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'deLocalFee', header: 'slot:deLocalFee', field: 'deLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'frLocalFee', header: 'slot:frLocalFee', field: 'frLocalFee', minWidth: '70px', align: 'right'},
                  {id: 'itLocalFee', header: 'slot:itLocalFee', field: 'itLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'esLocalFee', header: 'slot:esLocalFee', field: 'esLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'flLocalFee', header: 'slot:flLocalFee', field: 'flLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'seLocalFee', header: 'slot:seLocalFee', field: 'seLocalFee', minWidth: '80px', align: 'right'},
                  {id: 'plLocalFee', header: 'slot:plLocalFee', field: 'plLocalFee', minWidth: '80px', align: 'right'},
                ]
              },
            ]
            break;
          default:
            break;
        }
        
      }
    }
  }
</script>

<style lang="scss" scoped>
  .estimate-wrapper {
    height: 100%; 
    display: flex; 
    flex-direction: column;
  }
  .estimate__header {
    padding: 16px 24px;
    border: 1px solid #e8e8e8;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    color: rgba(0,0,0,.85);
  }
  .estimate__content {
    padding: 16px 24px;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    box-sizing: border-box;
    overflow: auto;
  }
  .estimate__content p {
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
  }
  .estimate--title {
  
  }
  .no-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 12px;
  }
  .edit-form{
    display: flex;
  }
  .no-left_padding{
    /deep/ .el-input__inner{
      border-left-color: rgba($color: #000000, $alpha: 0);
      &:focus, &:hover{
        border-left-color:#1F6EEF;
      }
    }
  }
  .no-border{
    /deep/ .el-input-group__append{
      border-radius: 0;
    }
  }
  .row-height{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 17px;
    }
  }
  .info-form{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 20px;
    }
    /deep/ .el-form-item{
      margin-bottom: 12px;
    }
    /deep/ .gj-area-title{
      // margin-bottom: 24px;
    }
  }
</style>
